import { render } from "./OpenTask.vue?vue&type=template&id=0438b5bc"
import script from "./OpenTask.vue?vue&type=script&lang=js"
export * from "./OpenTask.vue?vue&type=script&lang=js"
script.render = render

export default script